module.exports = __webpack_public_path__ + "static/media/linkedin_full.bc44cdd25e050865be6ee40284da7ef8.svg";